module.exports = __webpack_public_path__ + "img/0-32.40b0e278.jpg";